module.exports = __webpack_public_path__ + "67e04deca90216380f9372ac508837ce.pdf";